var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgIconInfo48Filled = function SvgIconInfo48Filled(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "current",
    height: "current",
    viewBox: "0 0 48 48",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M24 7.3A16.7 16.7 0 1 0 40.7 24 16.72 16.72 0 0 0 24 7.3Zm1.7 25h-3.35V21.8h3.4l-.05 10.5Zm0-13.5h-3.35v-3h3.4l-.05 3Z",
    fill: "current"
  })));
};
export default SvgIconInfo48Filled;